// extracted by mini-css-extract-plugin
module.exports = {"PRODUCT_QUANTITY":"ProductQuantity_PRODUCT_QUANTITY__EmoUq","PRODUCT_QUANTITY__btn":"ProductQuantity_PRODUCT_QUANTITY__btn__18JJH"};